import type { WSTemporaryTrustedAccessRequestCreatedData } from '@shared/types';
import { wsClient } from './websocket';
import { handleTemporaryTrustedAccessSignal } from './temporaryTrustedAccessSignals';

let initialized = false;

export function initializeTemporaryTrustedAccessEvents() {
  if (initialized) return;
  initialized = true;

  wsClient.on('temporary-access:trusted-request-created', (message) => {
    const data = message.data as WSTemporaryTrustedAccessRequestCreatedData;
    handleTemporaryTrustedAccessSignal({
      requestId: data.requestId,
      identityId: data.identityId,
      temporaryDeviceId: data.temporaryDeviceId,
      source: 'ws'
    });
  });
}
